module.exports = __webpack_public_path__ + "static/content_sla-5edaf2ba4ef7ec1bc15a62f7f0c4ff4d.svg";